import { ACTION_TYPE, ModalAction } from '../../actions/modal'

export type State = {
  open: boolean
}

export const initialState: State = {
  open: false,
}

export function reducer(state = initialState, action: ModalAction): State {
  switch (action.type) {
    case ACTION_TYPE.TOGGLE_MODAL_POSTCAMPAIGN: {
      return {
        ...state,
        open: action.isOpen,
      }
    }
    default:
      return state
  }
}
